import { parseAbi } from 'viem';

/**
 * Minimal ERC-20 `transfer(address,uint256)` ABI used across transaction
 * decoding, preview construction, test fixtures, and policy-limit usage
 * aggregation.
 */
export const erc20TransferAbi = parseAbi([
  'function transfer(address to, uint256 amount) returns (bool)',
]);
